import { formatUnits, parseEther } from '@ethersproject/units';
import { BigNumber } from 'ethers';
import { useContext, useEffect, useState } from 'react';
import Detail from '../../../../../components/Detail';
import { TimeConversions } from '../../../../../config/constants';
import appContext from '../../../../../context/app/appContext';
import { formatPercentages, formatUSD } from '../../../../../helpers/formats';
import useIsMounted from '../../../../../hooks/useIsMounted';
import useClaimableStakingRewards from '../../../../../hooks/web3/vault/useClaimableStakingRewards';
import useSpoolEmissionPerSecond from '../../../../../hooks/web3/vault/useSpoolEmissionPerSecond';
import useTotalStakedSpool from '../../../../../hooks/web3/vault/useTotalStakedSpool';

const SpoolEmissionRewards = () => {
    const { claimableStakingRewards } = useClaimableStakingRewards();
    const { totalStakedSpool } = useTotalStakedSpool();
    const { spoolEmissionPerSecond } = useSpoolEmissionPerSecond();

    const { sdk } = useContext(appContext);
    const [apy, setApy] = useState('0');

    const isMounted = useIsMounted();

    useEffect(() => {
        if (!sdk || !spoolEmissionPerSecond || !totalStakedSpool) return;

        (async () => {
            try {
                const apy = !parseEther(totalStakedSpool.toString()).isZero()
                    ? BigNumber.from(spoolEmissionPerSecond)
                          .mul(TimeConversions.SECONDS_PER_YEAR)
                          .div(parseEther(totalStakedSpool.toString()))
                          .mul(100)
                    : '0';

                isMounted() && setApy(formatUnits(apy, 18));
            } catch (error) {
                console.log(error);
            }
        })();
    }, [sdk, spoolEmissionPerSecond, totalStakedSpool, isMounted]);

    return (
        <Detail
            title={`Your Emission Rewards (${formatPercentages(apy || 0)}% APY)`}
            value={
                <>
                    {claimableStakingRewards &&
                    Object.keys(claimableStakingRewards).length
                        ? formatUSD(claimableStakingRewards.spoolRewards['SPOOL'] || 0, 2)
                        : '0.00'}{' '}
                    $SPOOL
                </>
            }
        />
    );
};

export default SpoolEmissionRewards;
